import { useState, useEffect, useContext, useNavigate } from 'react'
import { useHistory } from 'react-router-dom'
import ResponsiveLayout from 'containers/Layouts/ResponsiveLayout'
import { StateContext, DispatchContext } from 'context/Provider'
import { Grid, Typography, Avatar, Paper,
    TableContainer, Table, TableHead, TableRow, TableCell
} from '@material-ui/core'

import Moment from 'moment'
import axios from 'axios'

import './style.css'

const AllMessages = () => {
    const history = useHistory()
    const appState = useContext(StateContext)
    const { authState } = appState

    const appDispatch = useContext(DispatchContext)
    const { globalDispatch } = appDispatch

    const [messages, setMessages] = useState([])

    const getMessages = async () => {
        const axiosInstance = axios.create({
            baseURL: 'https://sms.academeportal.com/api/'
        });

        const response = await axiosInstance.get(`messages/${authState.user.id}`)

        if (response.data) {
            setMessages(response.data)
        }

        globalDispatch({type: 'setIsLoading', value: false});
    }

    const messageTime = (date) => {
        let momentDdate = Moment(date)
        let relativeTime = momentDdate.startOf('hour').fromNow()
        if (relativeTime.includes('minutes ago' || relativeTime.includes('hours')) || relativeTime.includes('hour')) {
            return relativeTime
        }

        return momentDdate.format('MMMM D, YYYY hh:mm a')
    }

    useEffect(() => {
        globalDispatch({type: 'setIsLoading', value: true});
        getMessages()
    }, [])

    return (
        <ResponsiveLayout>
            <Grid container justify="center">
                <Grid item xs={12} md={8}>
                    { messages.length === 0 &&
                        <div id="empty-messages-placeholder">
                            <img id="empty-box" src="/images/empty-box.svg" alt="Empty Box" />
                            <h5>No Messages Found</h5>
                        </div>
                    }
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead>
                                { messages.length > 0 && messages.map((msg) => (
                                    <TableRow
                                        hover
                                        style={{cursor: 'pointer'}}
                                        key={msg.thread_id}
                                        onClick={() => {
                                            history.push(`/message/${msg.thread_id}`)
                                        }}
                                    >
                                        <TableCell style={{width: '50px'}}>
                                            <Avatar alt={msg.sender} src='/unknow/path'/>
                                        </TableCell>
                                        <TableCell>
                                            <Typography>{msg.sender}</Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Typography>{msg.subject}</Typography>
                                        </TableCell>
                                        <TableCell style={{textAlign: 'right'}}>
                                            <Typography>{messageTime(msg.created_at)}</Typography>
                                        </TableCell>
                                    </TableRow>
                                )) }
                            </TableHead>
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>
        </ResponsiveLayout>
    )
}

export default AllMessages